import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { PlansRepository } from "../../repositories";
import { HttpResponse } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class ExportPlanToCSVUsecase implements UseCase<BaseRequest<string>,HttpResponse<Blob>> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(param:  BaseRequest<string>): Observable<HttpResponse<Blob>> {
    return this.planRepository.exportPlanToCSV(param);
  }


}